<template>
    <div class="all-section-area">
        <MainHeaderTwo class="header-style-three" />
        <main class="main-content-wrap style-two">
            <OverviewBack />
            <LmsAcademyContent />
            <TopPerformers />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeaderTwo from '../Layouts/MainHeaderTwo'
import OverviewBack from '../Dashboards/LmsAcademy/OverviewBack'
import LmsAcademyContent from '../Dashboards/LmsAcademy/LmsAcademyContent'
import TopPerformers from '../Dashboards/LmsAcademy/TopPerformers'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'LmsAcademyPage',
    components: {
        MainHeaderTwo,
        OverviewBack,
        LmsAcademyContent,
        TopPerformers,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>